<template lang="es">
    <div>
         <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="6">
                       Creadores departamentales
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Registrar nuevo
                        </v-btn>
                    </v-col> 
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>

                <v-row class="d-flex align-end flex-column mb-4">
                    
                    <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1 align-end">
                        <v-text-field
                            append-icon="mdi-magnify"
                            outlined
                            dense
                            v-model="filtroBusqueda"
                            label="Buscar"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                        :headers="headers"
                        :items="usuarios"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="filtroBusqueda"
                        :items-per-page="10"
                        dense
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                    >
                    <template v-slot:item="{ item }">
                        <tr v-if="item.estadosId === 1 || true">
                            <td>{{ item.id }}</td>
                            <td>{{ item.nombreUsuario }}</td>
                            <td>{{ item.correoUsuario }}</td>
                            <td>{{ item.departamentoCreador }}</td>
                            <td>
                        :        <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>

                                <v-btn class="ma-2 d-none" small tile outlined color="indigo" @click="mostrarModalResetPass(item.nombreUsuario, item.id)">
                                    <v-icon left>mdi-lock-reset</v-icon> Restablecer contrase&ntilde;a
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Inicio:: Dialog para mostrar los datos de la etnia-->
    <v-dialog
        v-model="dialog"
        max-width="700px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosUsuario.nombreUsuario"
                                label="Nombre del usuario"
                                :rules="[
                                    required(
                                        'Nombre del municipio'
                                    )
                                ]"
                                maxlength="100"
                            ></v-text-field>
                        </v-col>

                        <v-col  cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosUsuario.correoUsuario"
                                label="Correo electrónico"
                                :rules="[
                                    required(
                                        'Correo usuario'
                                    ),
                                    validEmail('')
                                ]"
                                :disabled="accion===2 && false"
                                maxlength="100"
                            ></v-text-field>
                        </v-col> 
                       
                    </v-row>

                    <v-row>
                         <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosUsuario.puestosId"
                                :items="puestos"
                                class="required"
                                dense
                                outlined
                                :loading="ddPuestosLoading"
                                label="Puesto"
                                item-text="nombrePuesto"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Puesto'
                                    )
                                ]"
                            ></v-select>
                        </v-col>

                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosUsuario.departamentoCreadorId"
                                :items="deptos"
                                class="required"
                                dense
                                outlined
                                :loading="ddDeptosLoading"
                                label="Departamento"
                                item-text="nombreDepartamento"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Departamento'
                                    )
                                ]"
                            ></v-select>
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <!-- Inicio:: Dialog para para restablecer contraseña-->
    <v-dialog
        v-model="dialogResetPass"
        max-width="600px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                Restablecer contrase&ntilde;a
                
                <v-spacer></v-spacer>
                <v-btn
                    icon

                    @click="dialogResetPass = false"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                    ref="resetPassForm"
                    v-on:submit.prevent="restablecerContrasenia"
                    >
            <v-card-text>
                <v-container>
                    <h4>Está seguro de restablecer la contrase&ntilde;a para {{nombreUsuario}}</h4>
                </v-container>
            </v-card-text>
            <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            color="grey lighten-5"
                            elevation="0"
                            :disabled="btnResetPassLoading"
                            class="mb-2 float-right grey lighten-5"
                            @click="dialogResetPass = false"
                        >
                            Cancelar
                        </v-btn>
                        <!--:disabled="!validDocForm" type="submit"-->
                        <v-btn
                            color="primary"
                            class="mb-2 float-right"
                            type="submit"
                            :elevation="0"
                            :loading="btnResetPassLoading"                           
                        >
                            Restablecer
                        </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    

    <!-- Fin:: Dialog para restablecer contraseña-->
    <!-- Fin:: Dialog para mostrar los datos de la etnia-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_USUARIOS_CREADORES, OBTENER_USUARIO_CREADOR, REGISTRAR_USUARIO_CREADOR, ACTUALIZAR_USUARIO_CREADOR} from "@/core/services/store/usuarios/creadordepartamental.module";

import { OBTENER_PUESTOS } from "@/core/services/store/puesto.module";
import { OBTENER_DEPARTAMENTOS} from "@/core/services/store/catalogos/departamento.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
export default {
    name: "AdminCreadoresDepartamentales",
    components: {
    SnackAlert,
    DialogLoader
    },
        data() {
        return {
            tableLoading: false,
            filtroBusqueda:'',
            validForm:false,
            ddPuestosLoading:false,
            ddDeptosLoading:false,
            ddMunicipiosLoading:false,
            itemName : "Usuarios Institucionales",
            dialog: false,
            dialogResetPass:false,
            modalTitle: 'Registrar Usuario',
            btnRegistroLoading: false,
            btnResetPassLoading:false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Usuario',
            accion: 1,
            showPass:false,
            Pais_Id: 0,
            puestos: [],
            deptos:[],
            departamentoId:0,
            
            usuarios: [],
            departamentos: [],
            switchItemEstado: true,
            nombreUsuario:'',
            idUsuario:0,
            datosUsuario: {
                id: 0,
                nombreUsuario: '',
                correoUsuario: '', 
                estadosId: 1,
                puestosId: 0,
                departamentoCreadorId:0,
                departamentosId:0,
                roles:[
                    {
                        idRol: 5
                    }
                ]
            },
            archivoRespaldo:[],
            archivoCargado: false,
            ...validations
        } 
    },
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Creador';
            this.btnRegistroText='Registrar Creador';
            this.dialog=true;
        },

        resetForm(){
            //this.$refs.form.reset();
            this.datosUsuario={
                id: 0,
                nombreUsuario: '',
                correoUsuario: '', 
                estadosId: 1,
                puestosId: 0,
                rolUsuarioId:4,
                departamentoCreadorId:0,
                roles:[
                    {
                        idRol: 5
                    }
                ]
            };
            this.archivoRespaldo=[];
            this.archivoCargado=false;
            this.switchItemEstado = true;
            this.municipios=[];
        },

        onFileChange(e){
            if(e){
                //!?Validar que el tipo de archivo sea pdf
                if (e.type != "application/pdf"){
                    // Api call
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `El archivo que desea ingresar no es válido.`);
                    //console.log("no es un pdf..")
                    //this.$refs.file.reset();
                    document.querySelector('#respaldoFile').value = '';
                    this.$refs.respaldoFile.reset();
                    return false;
                }
                //?Validar que el tamaó del archivo no exceda los 5Mb
                if ((e.size/1024/1024) > 5){
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `El tamaño del archivo excede el límite permitido (5Mb)`);
                    // this.$refs.file.reset();
                    document.querySelector('#respaldoFile').value = '';
                    this.$refs.respaldoFile.reset();
                    return false;
                }

                this.archivoRespaldo = e;
            }
        },

        //!Obtener los puestos para asignar al usuario
        async obtenerPuestos(){
            this.ddPuestosLoading =true;
            this.puestos=[];
            await this.$store
                .dispatch(OBTENER_PUESTOS, 1)
                .then(res => {
                    if(res.status==200){
                        this.puestos = this.$store.state.puesto.puestos;
                    }
                    this.ddPuestosLoading =false;
                //console.log(this.etnias)
                })
                .catch(err => {
                    this.ddPuestosLoading =false;
                    console.warn(err)
                });
        },


        //!Obtener los departamentos para la tabla
        async obtnenerDepartamentos(){
            this.ddDeptosLoading = true;
            this.deptos=[];
            
            await this.$store
                .dispatch(OBTENER_DEPARTAMENTOS,1)
                .then(res => {
                    if(res.status==200){
                        this.deptos = this.$store.state.departamento.departamentos;
                    }
                    this.ddDeptosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddDeptosLoading = false;
                });

        },
     

        //!Obtener las etnias para la tabla
        async obtnenerItems(){
            this.tableLoading = true;
            this.usuarios=[];
            await this.$store
                .dispatch(OBTENER_USUARIOS_CREADORES)
                .then(res => {
                    if(res.status===200){
                        this.usuarios = this.$store.state.creadordepartamental.usuariosCreadores;
                    }
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosUsuario.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Creador';
            this.btnRegistroText='Actualizar Creador';

            this.$store
                .dispatch(OBTENER_USUARIO_CREADOR, Id)
                .then(res => {
                    if(res.status===200){
                    this.datosUsuario = this.$store.state.creadordepartamental.usuarioCreador;
                    this.datosUsuario.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                    //this.datosUsuario.Contrasenia = '222222@2021';
                        //this.obtenerDepartamentos().then(()=>{
                    this.dialog = true;
                            
                    } else{
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.dialogLoaderVisible = false;
                    //});
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.log(error)
                });
        },
        
       
        async registrarItem(){

            delete this.datosUsuario.municipiosId;
            this.btnRegistroLoading=true;

            this.switchItemEstado ? this.datosUsuario.estadosId = 1 : this.datosUsuario.estadosId = 2;

                    if(this.accion===1){
                        this.datosUsuario.id = 0;
                        this.datosUsuario.departamentosId = this.datosUsuario.departamentoCreadorId;
                        await this.$store
                            .dispatch(REGISTRAR_USUARIO_CREADOR, this.datosUsuario)
                            .then(res => {
                                //console.log(res)
                                if(res.status===200){
                                    this.obtnenerItems();
                                    this.dialog=false;
                                    this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                                    this.resetForm();
                                    this.switchItemEstado = true;
                                } else {
                                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                                }
                                this.btnRegistroLoading=false;
                            })
                            .catch(error => {
                                //console.log(error)
                                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                                this.btnRegistroLoading=false;
                            });

                                

                    } else {
                        this.datosUsuario.departamentosId = this.datosUsuario.departamentoCreadorId;
                        this.datosUsuario.deptoCreadorId = this.datosUsuario.deptoCreador;
                        await this.$store
                            .dispatch(ACTUALIZAR_USUARIO_CREADOR, this.datosUsuario)
                            .then(res => {
                                //console.log(res)
                                if(res.status===200){
                                    this.obtnenerItems();
                                    this.dialog=false;
                                    this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                                    this.resetForm();
                                    this.switchItemEstado = true;
                                } else {
                                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                                }
                                this.btnRegistroLoading=false;
                            })
                            .catch(error => {
                                //console.log(error)
                                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                                this.btnRegistroLoading=false;
                            });
                    }
        },

        /**
        * Modal de confirmacion de cambio de contraseña
        */
       mostrarModalResetPass(nombreUsuario, id){
           this.dialogResetPass=true;
           this.nombreUsuario = nombreUsuario;
           this.idUsuario = id;
       },
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Inicio", route: "/dashboard" },
            { title: "Usuarios" },
            { title: "Creadoers Departamentales" },
        ]);
    },

    created(){
        this.obtnenerItems();
        this.obtenerPuestos();
        this.obtnenerDepartamentos();
    },

    computed: {
        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Nombre del usuario",
                    value: "nombreUsuario"
                },
                                {
                    text: "Correo",
                    value: "correoUsuario"
                },
                {
                    text: "Departamento",
                    value: "departamentosId"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
<style lang="">
    
</style>